export const MAX_ZOOM = 100;
export const MIN_ZOOM = 20;

export function getValidZoomPercentage(requestedZoomPrecentage: number) {
  const newZoomPercentage = Math.min(
    Math.max(requestedZoomPrecentage | 0, MIN_ZOOM),
    MAX_ZOOM,
  );
  return newZoomPercentage;
}

export function getDecreasedZoomPercentageBy10(zoomPrecentage: number) {
  const newZoomPercentage =
    zoomPrecentage % 10 === 0
      ? zoomPrecentage - 10
      : ((zoomPrecentage / 10) | 0) * 10;
  return getValidZoomPercentage(newZoomPercentage);
}

export function getIncreaseZoomPercentageBy10(zoomPrecentage: number) {
  const newZoomPercentage = (((zoomPrecentage + 10) / 10) | 0) * 10;
  return getValidZoomPercentage(newZoomPercentage);
}
